import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ccd405c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-user-slice" }
const _hoisted_2 = { class: "unlogged-section" }
const _hoisted_3 = ["onClick"]

import {getSliceComponentProps} from '@prismicio/vue';
    import {HeaderUserSliceSlice} from '@/unlogged/prismicio';
    import ServerSideNavigationPrismicLink from '../components/ServerSideNavigationPrismicLink.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderUserSlice',
  props: getSliceComponentProps<HeaderUserSliceSlice>(),
  setup(__props) {

    

    function openSigninModal() {
        Hop.connect.control.showSigninPopup(document.body, false);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ServerSideNavigationPrismicLink, {
        field: _ctx.slice.primary.signUpLink,
        class: "sign-up-button",
        "data-testid": "navbar-signup-cta",
        "data-heap": _ctx.slice.primary.signUpHeapId
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.slice.primary.signUpText), 1)
        ]),
        _: 1
      }, 8, ["field", "data-heap"]),
      _createElementVNode("button", {
        class: "sign-in-button",
        "data-testid": "navbar-signin-cta",
        onClick: _withModifiers(openSigninModal, ["prevent"])
      }, _toDisplayString(_ctx.slice.primary.signInText), 9, _hoisted_3)
    ])
  ]))
}
}

})